import React from 'react';
import '../components/styles/Footer.css';

const Footer = () => {
  return (
    <div className='footer'>
        <div className="d-flex top">
            <div className="col-md-1">
                <a href='https://bedrocklauncher.github.io/credits'>Credits</a>
            </div>
            <div className="col-md-1">
                <a href='https://github.com/BedrockLauncher/BedrockLauncher'>Source</a>
            </div>
            <div className="col-md-1">
                <a href="https://github.com/BedrockLauncher/BedrockLauncher/tree/master/docs/LICENSE.md">License</a>
            </div>
            <div className="col-md-1">
                <a href="https://github.com/BedrockLauncher/BedrockLauncher/releases">Releases</a>
            </div>
        </div>
        <div className="imgs d-flex">
            <div className="col-md-3">
                <img src="https://bedrocklauncher.github.io/static/media/CarJem_standalone.19a73997.gif" alt="" />
                <h6 className='heading'>Carjem</h6>
                <h6 className='hover'>Creator of Bedrock Launcher</h6>
            </div>
            <div className="col-md-3">
                <img src="https://bedrocklauncher.github.io/static/media/CoolAbhi1290.382eb5b0.png" alt="" />
                <h6 className='heading'>TrésAbhi</h6>
                <h6 className='hover'>Creator of Bedrock Launcher's <br /> Website</h6>
            </div>
            <div className="col-md-3">
                <img src="https://github.com/KalmeMarq.png?size=80" alt="" />
                <h6 className='heading'>KalmeMarq</h6>
                <h6 className='hover'>Developer of Bedrock Launcher's Website</h6>
            </div>
        </div>
        <div className="footerp">
            <a href="https://bedrocklauncher.github.io/credits">Carjem 2021-2022 © Not associated or approved by Mojang</a>
        </div>
    </div>
  )
}

export default Footer